import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25542f56")

_pushScopeId("data-v-25542f56")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "assistDesc"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkTitle = _resolveComponent("checkTitle")
  const _component_checkDescrip = _resolveComponent("checkDescrip")
  const _component_checkContent = _resolveComponent("checkContent")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "ui__checkItem_main",
      id: _ctx.renderData.itemCode
    }, [
      _createVNode(_component_checkTitle, {
        itemCode: _ctx.renderData.itemCode,
        titleCont: _ctx.renderData.itemTitle,
        count: _ctx.renderData.itemCount
      }, null, 8, ["itemCode", "titleCont", "count"]),
      (_ctx.renderData.itemCode === 'Accident' || _ctx.renderData.itemCode === 'Fire' || _ctx.renderData.itemCode === 'SoakWater')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_checkDescrip, {
              itemCode: _ctx.renderData.itemCode
            }, null, 8, ["itemCode"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_checkContent, {
        carContentRenderData: _ctx.renderData.itemList,
        carContentParentCode: _ctx.renderData.itemCode,
        carContentParentIndex: _ctx.dataIndex
      }, null, 8, ["carContentRenderData", "carContentParentCode", "carContentParentIndex"]),
      (_ctx.state.reportDetectVersion === 231107 && _ctx.renderData.itemCode === "Accident")
        ? (_openBlock(), _createBlock("p", _hoisted_2, "说明：※代表辅助检测项，其缺陷仅供用户参考，不作为事故车或重大事故车的判定依据。"))
        : _createCommentVNode("", true)
    ], 8, ["id"]),
    _hoisted_3
  ]))
})